import React, { useState, useEffect } from 'react'



//import { ApiCallGet } from '../../ApiCall/ApiCall';
import { ApiCallGet } from '../../../../ApiCall/ApiCall';
import "./ClientMenu.css"
import { useLocation, useNavigate } from "react-router-dom";

function EstadosGlobal({ setRfc, setEstado, register, especialidades, errors, id }) {

  const [countryArr, setCountryArr] = useState([])
  const [stateArr, setStateArr] = useState([])
  const [ciudadArr, setCiudadArr] = useState([])
  const [isFirst, setIsFirst] = useState(true)


  var navigate = useNavigate();
  const location = useLocation();


  

  function onAgenda()
  {

    //console.log( "location.state = "  , location.state )
    //return ;

    if ( location.state === -1 )
    {
      //alert( "Ya lo pezque")

      navigate("/session" , { state : { isClient : true } }) // Lo forzamos a cliente

      return ;
    }

    navigate( "/agenda" , { state : location.state  }) 
  }


  useEffect(() => {


    var theEstado =
    {
      country: document.getElementById('country').value,
      estado: document.getElementById('estado').value,
      ciudad: document.getElementById('ciudad').value

    }

    console.log("cambio de ciudad = ", theEstado)

    setEstado(theEstado);

  }, [ciudadArr])

  function onStateChange() {
    console.log("On state change")
    ApiCallGet('/cities?state=' + document.getElementById('estado').value)
      .then((response) => {

        var arr = []




        for (var i = 0; i < response.length; i++) {

          var obj = {

            id: response[i].id,
            name: response[i].name

          }

          arr.push(obj)

        }

        setCiudadArr(arr)

      })


  }

  useEffect(() => {

    if (!isFirst) {
      return;
    }

    setIsFirst(false);

    ApiCallGet('/cities?state=' + document.getElementById('estado').value)
      .then((response) => {

        var arr = []




        for (var i = 0; i < response.length; i++) {

          var obj = {

            id: response[i].id,
            name: response[i].name

          }

          arr.push(obj)

        }

        setCiudadArr(arr)


        var theEstado =
        {
          country: document.getElementById('country').value,
          estado: document.getElementById('estado').value,
          ciudad: document.getElementById('ciudad').value

        }
        console.log("Cambio de estado = ", theEstado)

        setEstado(theEstado);


      })
      .catch((err) => {

        console.log(err)

      })

  }, [stateArr])

  function onCountryChange() {
    console.log("Se ha detectado cambio de country")

    ApiCallGet('/states?country=' + document.getElementById('country').value)
      .then((response) => {

        var arr = []

        console.log("regresando de response")

        //return ;



        console.log("response = ", response)

        for (var i = 0; i < response.length; i++) {

          var obj = {

            id: response[i].id,
            name: response[i].name

          }

          arr.push(obj)

        }

        setStateArr(arr)


      })
      .catch((err) => {

      })

  }


  useEffect(() => {

    ApiCallGet("/countries")
      .then((response) => {

        var arr = []

        console.log("regresando de response")

        //return ;



        console.log("response = ", response)

        for (var i = 0; i < response.length; i++) {

          var obj = {

            id: response[i].id,
            name: response[i].name

          }

          arr.push(obj)

        }

        setCountryArr(arr)

      })
      .catch((err) => {
        console.log(err)
      })

  }, [])

  useEffect(() => {

    // if ( !isFirst )
    // {
    //     return ;
    // }

    // '142' es el pais mexico
    //document.getElementById('country').value = '142' ;

    //onCountryChange() // Para que seleccione el estado

    var theEstado =
    {
      country: document.getElementById('country').value,
      estado: document.getElementById('estado').value,
      ciudad: document.getElementById('ciudad').value

    }

    console.log("country = ", theEstado)


    setEstado(theEstado);

  }, [countryArr])




  function setRfcPrev(val) {
 //console.log( "Rfc = " + val.target.value)

    setRfc(val.target.value)
  }


  return (
    <>
      <div className='row  w-100'>
        <div className="col" >
          <select className="form-select selectOption" id="Especialidad" {
            ...register("id_especialidad", {
              required: {
                value: true,
                message: "La especialidad es requerida."
              }
            })
          }>
            <option>Seleccione la Especialidad</option>
            {especialidades.map((esp) => {
              return <option value={esp.id_especialidad}>{esp.especialidad_name}</option>
            })}
          </select>

          {
            errors?.id_especialidad?.type === "required" && (
              <p className="warning-message">
                {
                  errors.id_especialidad.message
                }</p>
            )
          }
        </div>
        <div className='col'>
          <select className="form-select selectOption" id="country" title='country'
            onChange={onCountryChange} {...register("id_country", {
              required: {
                value: true, 
                message: "El país es requerido"
              }
            })}>

            <option>Seleccione un país</option>

            {countryArr.map(v => <option key={
              v.id
            } value={
              v.id
            }>

              {v.name}
            </option>
            )}
          </select>
        </div>
        <div className='col'>
          <select className="form-select selectOption" id="estado" title='estado' onChange={onStateChange} {...register("id_state", {
            required: {
              value: true,
              message: "El estado es requerido"
            }
          })}>

            <option>Seleccione un estado</option>
            {stateArr.map(v => <option key={
              v.id
            } value={
              v.id
            }>
              {v.name}
            </option>
            )}
          </select>
        </div>
        <div className='col'>
          <select className="form-select selectOption" id="ciudad" title='estado' {...register("id_city")}>

            <option>Seleccione una ciudad</option>
            {ciudadArr.map(v => <option key={
              v.id
            } value={
              v.id
            }>
              {v.name}
            </option>
            )}
          </select>
        </div>

        <div className="col">
{/*          <a className="btn btn-primary boton-agenda" onClick={() => {
            return navigate("/agenda", {state: {register: register, id: id}})
*/}
          <a className="btn btn-primary boton-agenda" onClick={onAgenda} >Buscar</a>
        </div>
      </div>
    </>

  )
}

export default EstadosGlobal
